"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientDependenciesSchema = undefined;

var _schema = require("../common/schema");

var schema = _interopRequireWildcard(_schema);

var _messages = require("../common/messages");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clientDependenciesSchema = exports.clientDependenciesSchema = schema.create("client dependency", _messages.configError, {
  getDebug: {
    types: ["function"]
  },
  getEmail: {
    types: ["function"]
  },
  getHubId: {
    types: ["function"]
  },
  getHstc: {
    types: ["function"]
  },
  getLang: {
    types: ["function"]
  },
  getTempStorage: {
    types: ["function"]
  },
  setTempStorage: {
    types: ["function"]
  },
  logMessage: {
    types: ["function"],
    default: function _default(msg) {
      return console.log(msg);
    }
  },
  logError: {
    types: ["function"],
    default: function _default(err) {
      return console.error(err);
    }
  },
  reportError: {
    types: ["function"]
  },
  send: {
    types: ["function"]
  }
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.87/js/client/schemas.js
// module id = 418
// module chunks = 0